import { render } from "./FieldAdd.vue?vue&type=template&id=b5a28de8"
import script from "./FieldAdd.vue?vue&type=script&lang=js"
export * from "./FieldAdd.vue?vue&type=script&lang=js"

import "./FieldAdd.vue?vue&type=style&index=0&id=b5a28de8&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__